interface PaginationInfoProps {
  currentPage: number;
  pageSize: number;
  totalItems: number;
  itemLabel?: string;
}

export function PaginationInfo({ currentPage, pageSize, totalItems, itemLabel = 'tools' }: PaginationInfoProps) {
  if (totalItems === 0) return null;

  const start = (currentPage - 1) * pageSize + 1;
  const end = Math.min(currentPage * pageSize, totalItems);

  return (
    <div className="text-center text-sm text-muted-foreground mb-8">
      Showing {start} to {end} of {totalItems} {itemLabel}
    </div>
  );
} 